import * as oPath from '../../../../Lib/Object/Path/Immutable';

// Only props you want to override on the consumer need to be returned.
export const getAdminProviderProps = (consumerProps, providerData) => {
  const { name, onChange: consumerOnChange, value: consumerValue, copyTo } = consumerProps;
  const { setValue, synchronise, data } = providerData;

  let providerProps = { hasInjectedProps: true };

  // Set value
  if (name && consumerValue === undefined) {
    let value = oPath.get(data, name);
    if (value === undefined) value = null; // Remove undefined
    providerProps.value = value;
  }

  // Set onChange
  if (name && !consumerOnChange) {
    const onChange = ({ data: { value, submitValues = false } = {} }) => {
      if (name !== undefined && value !== undefined) {
        setValue({ name, value, sync: submitValues });
        copyTo?.forEach((d) => setValue({ name: d, value, sync: submitValues }));
      } else if (submitValues) synchronise();
    };

    providerProps.onChange = onChange;
  }

  return providerProps;
};
